import { Card, Flex } from "antd";
import { Link } from "react-router-dom";

import RefreshIcon from "@/icons/RefreshIcon";

import { getRepeatText } from "@/utils/repeatText";

import routes from "@/routes";

const PeriodicalSection = ({ data, isAdmins, unit_uuid, repeatRules }) => {
  return (
    <Card>
      <Flex vertical gap={10}>
        <Flex style={{ color: "#aeaeae" }} align="center" gap={5}>
          <RefreshIcon style={{ fontSize: 14 }} />
          <div style={{ marginTop: 2 }}>Периодичность</div>
        </Flex>
        <Flex vertical gap={5}>
          <div>{getRepeatText(repeatRules)}</div>
          {data.template_uuid && (
            <Link
              to={
                isAdmins
                  ? routes.administration.taskTemplateDetail(data.template_uuid)
                  : unit_uuid
                    ? routes.unitTaskTemplateDetail(
                        unit_uuid,
                        data.template_uuid,
                      )
                    : routes.taskTemplateDetail(data.template_uuid)
              }
            >
              Подробнее
            </Link>
          )}
        </Flex>
      </Flex>
    </Card>
  );
};

export default PeriodicalSection;
